export default {
  creditAppDeals: [],
  creditType: null,
  isLoading: false,
  isPaymentsInfoLoaded: false,
  leaseMileageRange: null,
  leaseTerm: null,
  loanTerm: null,
  dealDetails: {},
  dealNotifications: {},
  downPayment: null,
  downPaymentPercent: null,
  budget: null,
  dealType: null,
  interestRate: {},
  tradeIn: {
    value: null,
    amountOwed: null,
    condition: null,
    source: null,
    ico: []
  },
  monthlyBudget: null,
  icoTradeIn: {},
  lastUpdated: null,
  createdDate: null,
  hasPreviousPaymentInfo: false,
  paymentOption: 'finance',
  interactions: {
    autoFilledListing: {},
    disablePaymentPopover: false,
    disableComparePopover: false,
    disableBudgetCalculationAlert: false,
    useFallbackLead: false,
    hasOpenedTradeIn: false,
    hasOpenedWallet: false,
    hasUpdatedCreditOrTerm: false,
    hasUpdatedNDSCalc: false,
    hasUpdatedWallet: false,
    hasWalletInteractionWithinVDP: false,
    hasUpdatedPaymentOption: false,
    hasRequestedTaxesFees: false,
    hasBudgetInteraction: false,
    paymentEmphasis: false,
    hideReceipt: []
  },
  penciling: {
    customLender: {},
    offerPrice: null,
    icoTradeInOffer: null,
    pencilingPayments: {},
    penciledVdpListings: []
  },
  myWallet: {
    displayModal: false,
    hideBackButton: false,
    listingId: null,
    listingCategory: null,
    selectedPanelName: null,
    showPaymentDetailsModal: false,
    showPencilingPayments: false,
    displayWalletErrorMessage: false,
    configs: {}
  },
  creditVerification: {
    verified: false,
    verifiedDate: null
  },
  listingPayments: {},
  listingIncentives: {},
  listingLeasePayments: {},
  listingCashPayments: {},
  zip: null,
  timeStamp: null,
  previousPaymentInfo: {},
  walletId: null,
  hasSessionWalletChange: false
};